import type { CampaignConfiguration } from './api';
const fmt = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Berlin',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});
export function berlinInput(iso: string): string {
  return fmt.format(new Date(iso)).replace(' ', 'T');
}
export function berlinDate(value: string): string {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value))
    throw new Error('Bitte Datum und Uhrzeit vollständig angeben.');
  const desired = Date.parse(value + 'Z');
  if (!Number.isFinite(desired)) throw new Error('Ungültiges Datum.');
  const choices = [desired - 3600000, desired - 7200000].filter(
    (t) => berlinInput(new Date(t).toISOString()) === value,
  );
  if (choices.length !== 1)
    throw new Error(
      'Diese Uhrzeit ist durch die Zeitumstellung nicht eindeutig. Bitte wähle eine andere Uhrzeit.',
    );
  return new Date(choices[0]!).toISOString();
}
export function newCampaignConfiguration(now = new Date()): CampaignConfiguration {
  const start = new Date(now.getTime() + 86400000),
    end = new Date(now.getTime() + 8 * 86400000);
  return {
    name: '',
    template: 'T1',
    tier: 'premium',
    storefront: 'DEU',
    discountMinor: null,
    renewalMinor: null,
    currency: 'EUR',
    cycles: 3,
    period: 'P1M',
    startsAt: start.toISOString(),
    endsAt: end.toISOString(),
    timeZone: 'Europe/Berlin',
    redemptionWindowDays: 7,
    maxAssignments: 20,
    maxReservedMinor: 15000,
    pushRequested: false,
    title: 'Dein persönliches Angebot',
    body: 'Setze deine Prüfungsvorbereitung mit Premium fort.',
  };
}
